const formatCurrencyForDisplay = (centsInteger: number): string =>
  `$${(centsInteger / 100)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

export default formatCurrencyForDisplay;
